import {NotifyPropertyChanged} from '../utils/NotifyPropertyChanged.js';
import {LevelState} from './levelState.js';
import {vec3} from 'gl-matrix';

export enum State {
    Init,
    Title,
    Pause,
    Playing,
    End,
    Complete,
}

export class GameState extends NotifyPropertyChanged<GameState> {
    levelState: LevelState;

    private _state = State.Init;
    set state(value) {
        const oldState = this._state;
        this._state = value;
        this.notifyPropertyChanged('state', this._state, oldState);
    }
    get state() {
        return this._state;
    }

    private _availableTargets = 0;
    set availableTargets(value) {
        this._availableTargets = value;
        this.notifyPropertyChanged('availableTargets');
    }
    get availableTargets() {
        return this._availableTargets;
    }

    private _level: number | 'Title' = -1;
    set level(value) {
        this._level = value;
        this.notifyPropertyChanged('level', this._level);
    }
    get level() {
        return this._level;
    }

    private _playerPosition = vec3.create();
    set playerPosition(value) {
        this._previousPlayerPosition = this._playerPosition;
        this._playerPosition = value;
        this.notifyPropertyChanged('playerPosition', this._playerPosition, this._previousPlayerPosition);
    }
    get playerPosition() {
        return this._playerPosition;
    }
    private _previousPlayerPosition = vec3.create();
    get previousPlayerPosition() {
        return this._previousPlayerPosition;
    }

    private _playerRotation = 0;
    set playerRotation(value) {
        this._previousPlayerRotation = this._playerRotation;
        this._playerRotation = value;
        this.notifyPropertyChanged('playerRotation', this._playerRotation, this._previousPlayerRotation);
    }
    get playerRotation() {
        return this._playerRotation;
    }

    private _previousPlayerRotation = 0;
    get previousPlayerRotation() {
        return this._previousPlayerRotation;
    }

    private _isInVR = false;
    set isInVR(value) {
        this._isInVR = value;
        this.notifyPropertyChanged('isInVR', this._isInVR);
    }
    get isInVR() {
        return this._isInVR;
    }

    offTarget() {
        this.availableTargets++;
    }

    onTarget() {
        this.availableTargets--;
        if (this.availableTargets == 0) {
            if (this.level == 14) {
                this.state = State.Title;
                this.playerRotation = 0;
                // Should be complete, but title for now to prevent crash
            } else {
                //@ts-ignore
                this.level++;
            }
        }
    }
}
